import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useApprovePaymentOrderGroup() {
  const [loading, setLoading] = useState(false);

  async function execute(paymentOrderGroupId: string): Promise<void> {
    try {
      setLoading(true);
      const response = await api.post(
        `v1/backoffice/payment-order-groups/${paymentOrderGroupId}:approve`,
      );

      if (response.status === 201) {
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
